import { render, staticRenderFns } from "./quitDelegate.vue?vue&type=template&id=1fb2364a&scoped=true"
import script from "./quitDelegate.vue?vue&type=script&lang=js"
export * from "./quitDelegate.vue?vue&type=script&lang=js"
import style0 from "./quitDelegate.vue?vue&type=style&index=0&id=1fb2364a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2364a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb2364a')) {
      api.createRecord('1fb2364a', component.options)
    } else {
      api.reload('1fb2364a', component.options)
    }
    module.hot.accept("./quitDelegate.vue?vue&type=template&id=1fb2364a&scoped=true", function () {
      api.rerender('1fb2364a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/quitDelegate/quitDelegate.vue"
export default component.exports